import {
	BrowserModule,
	HAMMER_GESTURE_CONFIG,
	HammerGestureConfig,
} from '@angular/platform-browser';
import { NgModule, LOCALE_ID, APP_ID, APP_INITIALIZER, ErrorHandler, importProvidersFrom } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { DEFAULT_MONTH_NAMES, DEFAULT_WEEK_DAYS } from '@app-shared/utils';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {provideNativeDateAdapter} from '@angular/material/core';
import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { AppStoreModule } from './store/app-store.module';
import { LayoutsModule } from './shared/layouts/layouts.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './services/auth-interceptor.service';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { registerLocaleData, APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { BrowserStateInterceptor } from './interceptors/browserstate.interceptor';
import localePT from '@angular/common/locales/pt';
import { NgxDaterangepickerBootstrapModule } from 'ngx-daterangepicker-bootstrap';
registerLocaleData(localePT);
import { provideCharts, withDefaultRegisterables} from 'ng2-charts';
import { DateFormatAdapter } from '@app-shared/config/date-format-adapter';
import plugin from 'chartjs-plugin-datalabels';
import 'chartjs-adapter-date-fns';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';

@NgModule({ declarations: [AppComponent],
    exports: [],
    bootstrap: [AppComponent], imports: [AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        AppStoreModule,
        LayoutsModule,
        NgxDaterangepickerBootstrapModule,
        MarkdownModule.forRoot()
    ], providers: [
        { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
        { provide: Sentry.TraceService, deps: [Router] },
        { provide: APP_INITIALIZER, useFactory: () => () => {}, deps: [Sentry.TraceService], multi: true },
        importProvidersFrom(NgxDaterangepickerBootstrapModule.forRoot({
            separator: ' - ',
      applyLabel: 'Selecionar',
      cancelLabel: "Cancelar",
       format: 'DD/MM/YYYY',
       monthNames: DEFAULT_MONTH_NAMES,
       daysOfWeek: DEFAULT_WEEK_DAYS

        })),
        provideCharts(
          withDefaultRegisterables(
            plugin,
            MatrixController,
            MatrixElement
          )
        ),
        { provide: APP_ID, useValue: 'app-a' },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: BrowserStateInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'pt' },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
        { provide: 'LOCALSTORAGE', useFactory: getLocalStorage },
        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
        {
            provide: APP_BASE_HREF,
            useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
            deps: [PlatformLocation]
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideNativeDateAdapter(),
    ] })
export class AppModule {
	constructor(trace: Sentry.TraceService) {}
}

export function getLocalStorage() {
	return typeof window !== 'undefined' ? window.localStorage : null;
}

